import visitorRegistrationConfig from '../../common/visitor-registration-config';
import identityFields from '../../common/identity-fields';
import { attendingReasons, numberOfEmployees, jobStatus, referralSource } from '../../common/generic-fields';
import purchaseFields from '../../common/purchase-fields';
import { terms, cactusConsent, promoCode, firstTime } from '../../common/registration-fields';

const industryCategories = {
	architecture: 'Architecture & Design',
	construction: 'Building & Construction',
	trades: 'Trades',
	facilities: 'Facilities and Building Services',
	engineering: 'Engineering',
	other: 'Other',
};

export default {
	show: 'BuildNZ',
	termsUrl: 'https://buildnz.com/show-info/',
	showId: 140,
	...visitorRegistrationConfig,
	form: [
		{
			fields: {
				...identityFields,
				...jobStatus,
				mainact: {
					wrapper: 'col-12',
					component: 'radio-input-group',
					label: 'Which category do you fit into best?',
					options: Object.values(industryCategories),
					reset: ['q1', 'q1_Other'],
				},
			},
		},
		{
			fields: {
				q1: [
					{
						conditions: {
							mainact: industryCategories.architecture,
						},
						wrapper: 'col-12',
						component: 'radio-input-group',
						label: 'Which best describes your job function?',
						options: [
							'Architect Commercial',
							'Architect Residential',
							'Architectural Draftsperson',
							'Specifier',
							'Interior Designer',
							'Designer',
							'Quantity Surveyor',
						],
					},
					{
						conditions: {
							mainact: industryCategories.construction,
						},
						wrapper: 'col-12',
						component: 'radio-input-group',
						label: 'Which best describes your job function?',
						options: [
							'Builder Commercial',
							'Builder Residential',
							'Builder Owner / Manager',
							'Cabinet Maker / Joiner',
							'Building Inspector',
							'Building Supply Merchant',
							'Project Manager',
							'Estimator',
							'Property Developer Commercial',
							'Property Developer Residential',
						],
					},
					{
						conditions: {
							mainact: industryCategories.trades,
						},
						wrapper: 'col-12',
						component: 'radio-input-group',
						label: 'Which best describes your job function?',
						options: [
							'Plumbing',
							'Electrician',
							'Roofing',
							'Painter / Paper Hanger',
							'Gas Fitter',
							'Drain Layer',
							'Flooring',
							'Kitchen',
							'Bathroom',
							'Tiling',
							'Locksmith',
							'Landscaper',
							'Brick layer',
							'Other',
						],
					},
					{
						conditions: {
							mainact: industryCategories.facilities,
						},
						wrapper: 'col-12',
						component: 'radio-input-group',
						label: 'Which best describes your job function?',
						options: [
							'Facility Manager',
							'Venue Manager',
							'Property Manager',
							'Maintenance Manager',
							'Other',
						],
					},
					{
						conditions: {
							mainact: industryCategories.engineering,
						},
						wrapper: 'col-12',
						component: 'radio-input-group',
						label: 'Which best describes your job function?',
						options: [
							'Electrical Engineer',
							'Engineer',
							'Structural Engineer',
							'Civil Engineer',
							'Maintenance Engineer',
							'Mechanical Engineer',
							'Software Engineer',
							'Network Engineer',
							'Robotics Engineer',
							'Chemical Engineer',
						],
					},
					{
						conditions: {
							mainact: industryCategories.other,
						},
						wrapper: 'col-12',
						component: 'radio-input-group',
						label: 'Which best describes your job function?',
						options: [
							'Government',
							'Education',
							'Consultant',
							'Sales',
							'Marketing',
							'Operations',
							'Purchasing',
							'Media',
							'Other',
						],
					},
				],
				q1_Other: {
					conditions: {
						q1: 'Other',
					},
					wrapper: 'col-12',
					component: 'text-input',
					label: 'Please specify',
					validationLabel: 'Which best describes your job function? Please specify',
				},
			},
		},
		{
			conditions: {
				mainact: Object.values(industryCategories),
			},
			fields: {
				q2: {
					wrapper: 'col-12',
					component: 'check-input-group',
					label: 'Which of the following products are you interested in?',
					newEntryReset: true,
					options: [
						'Aluminium Joinery',
						'Appliances',
						'Architectural Hardware',
						'Audio Visual',
						'BIM',
						'Bathroomware',
						'Blinds / Curtains / Shutters',
						'Builders Hardware',
						'Carpets, Rugs',
						'Cladding',
						'Computer Systems',
						'Construction Systems',
						'Decking',
						'Decorative Accessories',
						'Door / Screens',
						'Electrical Products / Services',
						'Fabrics, Textiles',
						'Fashion, Colour Forecasting',
						'Flooring',
						'Furnishings',
						'Furniture',
						'Gas Suppliers',
						'Glass',
						'Hand Tools',
						'Heating, Fireplaces',
						'Household Hardware',
						'Insulation',
						'Interior Design',
						'Kitchen, Benchtops',
						'Landscaping',
						'Lighting',
						'Locks and Latches',
						'Office Fitout Systems',
						'Paint and Paint Aids',
						'Plumbing Supplies',
						'Pools and Pool Accessories',
						'Power Tools',
						'Protective Coatings',
						'Roofing',
						'SIPs (Structural Insulated Panels)',
						'Shop Fittings',
						'Software',
						'Solar',
						'Stairs',
						'Surface & Wall Finishes',
						'Tiles',
						'Other',
					],
				},
				q2_Other: {
					conditions: {
						q2: 'Other',
					},
					wrapper: 'col-12',
					component: 'text-input',
					label: 'Please specify',
					validationLabel: 'Which of the following products are you interested in? Please specify',
					newEntryReset: true,
				},
				...attendingReasons,
				...numberOfEmployees,
				...purchaseFields,
				...referralSource,
			},
		},
		{
			fields: {
				...promoCode,
				...firstTime,
				...terms,
				...cactusConsent,
			},
		},
	],
};
